<template>
  <div class="col-10 box-border">
    <div class="my-3 mx-2 d-flex justify-content-between credit-limit-about">
      <div class="d-flex">
          <MoneyTax />
          <div class="ml-3">
            <caption class="c-nmidone bold">Valor geral</caption>
            <h4 class="bold c-ndarkfour">R$ {{creditLimit.totalCreditLimit | formatMoney}} </h4>
          </div>
      </div>
      <div class="d-flex">
          <MoneyTax backgroundColor="#FFF7E6" textColor="#FFAC00" />
          <div class="ml-3">
            <caption class="c-nmidone bold">Valor utilizado</caption>
            <h4 class="bold c-sorangefour">R$ {{creditLimit.usedCreditLimit | formatMoney}} </h4>
          </div>
      </div>
      <div class="d-flex">
          <MoneyTax backgroundColor="#EDF9F7" textColor="#33BDA3" />
          <div class="ml-3">
            <caption class="c-nmidone bold">Valor disponível</caption>
            <h4 class="bold c-greenfour">R$ {{creditLimit.availableCreditLimit | formatMoney}} </h4>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import MoneyTax from '@/components/icons/MoneyTax'

export default {
  props: {
    creditLimit: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  components: {
    MoneyTax,
  },
}
</script>
<style lang="scss">
.credit-limit-about {
  max-width: 968px;
}
</style>